module.exports = __webpack_public_path__ + "static/media/Hive dataset issues.ed77f2bc.txt";